import styled from 'styled-components';

export const SectionContainer = styled.div`
`;

export const WrapperSearchList = styled.div`
  padding: 15px 0;
`;

export const ChatSearchContent = styled.div`
	padding: 15px;
	border-bottom: 1px solid;
	border-color: ${props => props.borderColor};
	.InputWrapper {
	  input:not([type='radio']):not([type='checkbox']):not([type='file']) {
	    height: 30px;
	  }
	}
`;

export const ChannelNameWrapper = styled.div`
	color: ${props => props.textColor};
	background: ${props => props.backgroundColor};
	cursor: pointer;
	padding: 0 15px 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover {
    background: ${props => props.backgroundColorHover};
    .IconDelete {
      opacity: 0.5;
    }
  }
  .IconMute {
    margin-left: 10px;
  }
  .IconDelete {
    opacity: 0;
  }
`;

export const ChannelNameContainer = styled.div`
	line-height: 30px;
	flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ChannelName = styled.span`
	display: block;
	flex: 1;
	max-width: 180px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const EmptyContent = styled.div`
	padding: 15px;
	border-bottom: 1px solid;
	border-color: ${props => props.borderColor};
`;